import React from 'react';

export const Trust: React.FC = () => {
  return (
    <section className="bg-white border-y border-slate-100 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-900 mb-6">
          Built for advisors, portfolio teams, and compliance-minded professionals.
        </h2>
        <p className="text-lg text-slate-600 leading-relaxed">
          This course is education-first—designed to help you speak clearly about digital assets, respond to client questions, and understand how Bitcoin fits into the modern financial landscape.
        </p>
      </div>
    </section>
  );
};